<template>
  <div class="pt-28 custom tip">
    <el-dialog
      :visible.sync="editModal"
      centered
      width="30%"
      hide-header
      class="hide cust-mod cust1"
    >
      <div class="text-center">
        <p class="fsize18 sm-fsize16 font-semibold text-black pb-4 leading-2">
          {{ modal.title }}
        </p>
        <p class="sm-fsize14">{{ modal.description }}</p>
        <div class="text-center mt-6">
          <button
            class="bg-primary font-semibold text-white px-6 py-2 rounded-lg"
            @click="editModal = false"
          >
            OK
          </button>
        </div>
      </div>
    </el-dialog>
    <div
      id="communityMembership"
      class="lg:px-12 md:px-12 px-5 lg:mt-0 md:mt-0 mt-22rem mob-hidden"
    ></div>
    <div class="lg:px-10 md:px-10 px-5">
      <h1
        class="title text-center text-primary md:pb-4 lg:pb-4 pb-2 sm-fsize16 md:font-normal lg:font-normal font-bold"
      >
        Bring out the best within you as a caregiver
      </h1>
      <p class="subtitle text-center fsize18-14-32px lg:px-40 md:px-40 px-4">
        Access content, services & products curated with the efforts of
        thousands of caregivers across the country. Your road may be bumpy but
        we can make it better, together.
      </p>
      <p
        class="subtitle text-primary text-center font-semibold fsize18-14-32px lg:px-40 md:px-40 px-4"
      >
        Call us to decide which is the best plan for you.
      </p>

      <p
        class="subtitle text-primary text-center font-semibold fsize18-14-32px lg:px-40 md:px-40 px-4"
      >
        For corporate plans, please contact us at
        <a href="mailto:info@caregiversaathi.co.in"
          >info@caregiversaathi.co.in</a
        >
      </p>
      <div class="flex gap-0 lg:mt-0 md:mt-0 mt-6">
        <div class="custboshodow py-3 mt-5 w-25per md-w-40 sm-w-50">
          <div class="w-full">
            <div class="lg:pl-4 md:pl-4 pl-2 lg:pr-0 md:pr-4">
              <h2
                class="fsize22 text-black font-semibold lg:block md:block hidden"
              >
                Pricing Plan
              </h2>
              <h2
                class="fsize22 sm-fsize18 text-black font-semibold lg:hidden md:hidden block"
              >
                Pricing Plan
              </h2>
              <el-radio-group
                v-model="radio"
                class="py-2 lg:mt-0 md:mt-0 mt-4 h-150px"
              >
                <div
                  class="pt-2"
                  v-for="(item, index) in getUniqueMonth"
                  :key="index"
                >
                  <el-radio :value="item._id" :label="item._id" class="f12">{{
                    item._id == 12
                      ? "Pay Annually"
                      : `Pay for ${item._id} months`
                  }}</el-radio>
                </div>
                <!-- <div class="pt-2">
                  <el-radio v-model="radio" value="12" label="12"
                    >Pay Anually</el-radio
                  >
                </div>
                <div class="pt-2">
                  <el-radio v-model="radio" value="6" label="6"
                    >Pay for 6 months</el-radio
                  >
                </div>
                <div class="pt-2">
                  <el-radio v-model="radio" value="3" label="3"
                    >Pay for 3 months</el-radio
                  >
                </div> -->
              </el-radio-group>
            </div>
            <div class="borleft lg:pt-4 md:pt-4 pt-6">
              <div v-for="cat in getAllCategory" :key="cat" class="">
                <h2
                  class="text-primary font-semibold pl-4 py-2 bg-f0f0f0 fsize16"
                >
                  <!-- About -->{{ cat.name }}
                </h2>

                <div class="plans-tooltip">
                  <div v-for="item in getAllFeatures.featureRecord" :key="item">
                    <!-- <el-tooltip
                      v-if="cat._id == item.category._id"
                      class="item"
                      effect="dark"
                      :content="item.title"
                      placement="top-start"
                    > -->
                    <div
                      v-if="cat._id == item.category._id"
                      class="item flex items-center borbottom"
                      effect="dark"
                      :content="item.title"
                    >
                      <p
                        class="lg:pl-4 md:pl-4 px-2 lg:py-3 md:py-3 py-2 fsize14 sm-fsize12"
                      >
                        {{ item.title.slice(0, 25) }}...
                      </p>
                      <p
                        @click="handlemodal(item)"
                        class="lg:pr-4 md:pr-4 px-2 lg:py-3 md:py-3 py-2 fsize14 sm-fsize12 text-primary font-semibold cursor-pointer"
                      >
                        View More
                      </p>
                    </div>
                    <!-- </el-tooltip> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <swiper
          class="swiper w-75per md-w-60 marx-0 sm-w-50"
          :options="swiperOptions"
        >
          <swiper-slide
            v-for="membership in get_all_membership"
            :key="membership.id"
            class="mr-0px"
          >
            <div class="w-full mt-5 bdrs-1 lg:pt-0 md:pt-0 pt-4">
              <div class="lg:px-4 md:px-4 px-2 pt-2 h-210 sm-h-210">
                <div class="lg:h-28 h-24">
                  <h2
                    class="fsize20 md-fsize18 sm-fsize14 text-black font-semibold mb-0"
                  >
                    {{ membership.name }}
                  </h2>
                  <el-tooltip placement="top" :content="membership.description">
                    <p
                      class="text-gray font-medium md-fsize15 sm-fsize12 lh-norm lineclamp-2"
                    >
                      {{ membership.description }}
                    </p>
                  </el-tooltip>
                </div>
                <div v-for="month in membership.monthPrice" :key="month">
                  <p
                    class="text-primary font-bold fsize20 sm-fsize16"
                    v-if="
                      month.month == parseInt(radio) &&
                      !membership.contactUs &&
                      !month.isFree
                    "
                  >
                    <sup
                      class="line-through"
                      v-if="!membership.isFree && membership.discount > 0"
                    >
                      {{ `₹ ${month.price}` }}</sup
                    >
                    {{ `₹ ${month.discountPrice}` }}
                  </p>
                </div>
                <p
                  class="text-primary font-bold fsize20 sm-fsize16"
                  v-if="membership.isFree"
                >
                  {{ membership.contactUs ? "Let's Connect" : "Free" }}
                </p>
                <p
                  class="text-primary font-bold fsize20 sm-fsize16"
                  v-if="membership.contactUs"
                >
                  {{ membership.contactUs ? "Let's Connect" : "Free" }}
                </p>

                <div class="py-2" v-if="!membership.contactUs">
                  <el-tooltip
                    placement="top"
                    :content="
                      !isObjEmpty(getUserByUserId) &&
                      getUserByUserId.currentMembership != null &&
                      getUserByUserId.currentMembership._id === membership._id
                        ? 'Activated plan'
                        : 'Click here to activate this plan'
                    "
                  >
                    <base-button
                      class="fsize12 py-2 lg:px-8 md:px-8 px-4 w-full"
                      :outline="
                        !isObjEmpty(getUserByUserId) &&
                        getUserByUserId.currentMembership != null &&
                        getUserByUserId.currentMembership._id !== membership._id
                      "
                      type="primary"
                      @click="handleBuy(membership)"
                      :disabled="
                        !isObjEmpty(getUserByUserId) &&
                        getUserByUserId.currentMembership != null &&
                        getUserByUserId.currentMembership._id === membership._id
                      "
                    >
                      <!-- Sign up for free -->
                      {{
                        !isObjEmpty(getUserByUserId) &&
                        getUserByUserId.currentMembership != null &&
                        getUserByUserId.currentMembership._id === membership._id
                          ? "Activated"
                          : membership.isFree
                          ? "Activate"
                          : "Buy Now"
                      }}
                    </base-button>
                  </el-tooltip>
                </div>
                <div class="py-2" v-else>
                  <a href="mailto:info@caregiversaathi.co.in">
                    <el-tooltip placement="top" content="Click here to connect">
                      <base-button
                        class="fsize12 py-2 lg:px-8 md:px-8 px-4 w-full"
                        type="primary"
                      >
                        <!-- @click="() => $router.push({ name: 'home' })" -->
                        Contact-us
                      </base-button>
                    </el-tooltip>
                  </a>
                </div>
              </div>
              <div class="borleft">
                <div v-for="cat in getAllCategory" :key="cat">
                  <h2
                    class="text-primary font-semibold pl-4 py-5 bg-f0f0f0 fsize16"
                  >
                    {{ " " }}
                  </h2>

                  <div
                    class=""
                    v-for="item in getAllFeatures.featureRecord"
                    :key="item"
                  >
                    <p
                      v-if="cat._id == item.category._id"
                      class="pl-4 pycard text-center borbottom fsize14"
                    >
                      <feather-icon
                        v-if="membership.featureId.includes(item._id)"
                        icon="CheckIcon"
                        class="flex justify-center"
                        svgClasses="w-5 h-5"
                      />
                      <feather-icon
                        v-else
                        icon="XIcon"
                        class="flex justify-center"
                        svgClasses="w-5 h-5"
                      />
                    </p>
                  </div>
                </div>
              </div></div
          ></swiper-slide>
          <div
            class="swiper-button-prev custsubscribe"
            slot="button-prev"
          ></div>
          <div
            class="swiper-button-next custsubscribe"
            slot="button-next"
          ></div>
        </swiper>
      </div>
      <div class="py-6">
        <p
          class="subtitle text-primary text-center font-semibold fsize18-14-32px lg:px-40 md:px-40 px-4"
        >
          Call us to decide which is the best plan for you.
        </p>

        <p
          class="subtitle text-primary text-center font-semibold fsize18-14-32px lg:px-40 md:px-40 px-4"
        >
          For corporate plans, please contact us at
          <a href="mailto:info@caregiversaathi.co.in"
            >info@caregiversaathi.co.in</a
          >
        </p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import Footer from "@/views/Footer.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    Footer,
  },
  data() {
    return {
      modal: {},
      editModal: false,
      drawer: false,
      direction: "ltr",
      radio: 12,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        breakpoints: {
          1600: {
            slidesPerView: 4.2,
            spaceBetween: 10,
          },
          1300: {
            slidesPerView: 4.2,
            spaceBetween: 10,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          820: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 1.8,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
        },
        // loop: true,
        // autoplay: {
        //   delay: 6000,
        //   disableOnInteraction: true,
        // },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      currMembership: {},
      currTransactionId: "",
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handlemodal(data) {
      this.modal = data;
      this.editModal = true;
    },
    handleRegister(name) {
      this.$router.push({ name: name });
    },
    async handleBuy(membership) {
      if (Object.keys(this.getUserByUserId).length == 0) {
        this.$swal
          .fire({
            // title: "Are you sure?",
            html: "<p style='text-align:center'>Please sign-in first</p>",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#830c81",
            cancelButtonColor: "#d33",
            confirmButtonText: "Okay!",
          })
          .then(async (result) => {
            if (result.value == true) {
              this.$router.push({ name: "signin" });
            }
          });
        return;
      }
      let self = this;
      this.currMembership = membership;
      if (this.currMembership.isFree) {
        const payload = {
          userId: this.user._id,
          membershipId: this.currMembership._id,
          plansIncluded: this.currMembership.plansIncluded,
          membershipName: this.currMembership.name,
          price: 0,
          validity: parseInt(this.radio),
          // validity: parseInt(this.currMembership.validity),
          // orderId: responcenew.data.orderId,
          paymentStatus: "success",
        };
        const data = await this.$store.dispatch(
          "payment/createFreePayment",
          payload
        );
        this.init();
        return;
      }
      let selectedPrice = this.currMembership.monthPrice.find(
        (item) => item.month === this.radio
      );

      const totalPrice = selectedPrice ? selectedPrice.discountPrice : null;
      var amount = Number(totalPrice) * 100;
      var paymentRecord = async (response) => {
        var responcenew = await this.handlePaymentRecord(response);
        // console.log("HANDLEPAYMENTRECORD:", responcenew);
        this.currTransactionId = responcenew.data._id;
        if (responcenew) {
          const payload = {
            userId: this.user._id,
            membershipId: this.currMembership._id,
            plansIncluded: this.currMembership.plansIncluded,
            membershipName: this.currMembership.name,
            price: parseInt(totalPrice),
            transactionId: responcenew.data._id,
            validity: parseInt(this.radio),
            // validity: parseInt(this.currMembership.validity),
            orderId: responcenew.data.orderId,
            paymentStatus: "success",
          };

          let loader = this.$loading();
          try {
            const data = await this.$store.dispatch(
              "payment/CreatePayment",
              payload
            );
            // console.log("PAYMENTCREATE:", data);
            if (data.code == 200) {
              // this.success();
              // this.renderOperation();
              // this.$vs.loading.close();
              let TransPayload = {
                _id: responcenew.data._id,
                transactionstatus: "Success",
              };
              await this.$store.dispatch(
                "transaction/UpdateTransaction",
                TransPayload
              );
              let getUserPayload = {
                userId: this.user._id,
              };
              const getUser = await this.$store.dispatch(
                "auth/getUserByUserId",
                getUserPayload
              );
              this.$store.commit("auth/GET_USER_BY_USER_ID", getUser.data.user);
              // console.log("GETUSERBYUSERID:", this.getUserByUserId);
              loader.close();
              // console.log("payment success");
              // this.$router.push({ name: "myorder" });
            }
            loader.close();
          } catch (error) {
            // this.$vs.loading.close();
            // this.error(error);
            loader.close();
            console.log(error);
          }
        }
      };
      this.$store
        .dispatch("payment/CreateOrderPayment", {
          // amount: Number(amount),
          membership: membership._id,
          timePeriod: parseInt(this.radio),
        })
        .then(async (_) => {
          // console.log(_);
          if (Object.keys(_.data).length == 0) {
            // return this.$notify.error({
            //   message: "Payment failed",
            //   position: "bottom-right",
            // });
            // console.log("Payment failed");
            return;
          }
          var options = {
            key: process.env.RAZORPAY_KEY_ID,
            amount: _.data.amount.toString(),
            currency: "INR",
            name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
            description: `Membership Id: ${this.currMembership._id} / Membership Name: ${this.currMembership.name}`,
            order_id: _.data.id,
            handler: function (response) {
              paymentRecord(response);
            },
            prefill: {
              name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
              email: `${this.user.email || ""}`,
              phone: `${this.user.mobile || ""}`,
            },
          };
          var rzp1 = new Razorpay(options);
          rzp1.on("payment.failed", async function (response) {
            // console.log("FAILEDTRANSACTION");
            self.handleFaliedTransaction();
          });
          rzp1.open();
        })
        .catch((error) => {
          // this.checkoutMessage = "Out of Stock",
          //  this.$notify.error({
          //     message: "Out of Stock",
          //     position: "bottom-right",
          //   })
          console.log(error);
        });
    },
    async handlePaymentRecord(responce) {
      try {
        let payload = {
          transactionId: responce.razorpay_signature,
          transactionstatus: "In-Progress",
          transactionMode: "online",
          orderId: responce.razorpay_order_id,
          membershipId: this.currMembership._id,
          razorpayKey: {
            razorpay_payment_id: responce.razorpay_payment_id,
            razorpay_order_id: responce.razorpay_order_id,
            razorpay_signature: responce.razorpay_signature,
          },
        };
        const transactionrecord = await this.$store.dispatch(
          "transaction/CreateTransaction",
          payload
        );
        // console.log("TRANSACTIONCREATE:", transactionrecord);
        this.currTransactionId = transactionrecord.data._id;
        return transactionrecord;
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
    async handleFaliedTransaction() {
      let TransPayload = {
        _id: this.currTransactionId,
        transactionstatus: "Failed",
      };
      let data = await this.$store.dispatch(
        "transaction/UpdateTransaction",
        TransPayload
      );
      // console.log("FAILEDTRANSACTIONRESPONSE", data);
    },
    isObjEmpty(value) {
      if (Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
      }
      return false;
    },
    async init() {
      try {
        await this.$store.dispatch("subscribe/GetAllMembership");
        if (this.user && this.user._id) {
          let getUserPayload = {
            userId: this.user._id,
          };
          const getUser = await this.$store.dispatch(
            "auth/getUserByUserId",
            getUserPayload
          );
        }
        // console.log("INIT", this.getUserByUserId, this.get_all_membership);
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
      getAllFeatures: "getAllFeatures",
      getAllCategory: "getAllCategory",
    }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
    ...mapState("membership", {
      getUniqueMonth: "getUniqueMonth",
    }),
  },

  async mounted() {
    await this.$store.dispatch("subscribe/GetAllFeatures");
    await this.$store.dispatch("subscribe/getCategory");
    await this.$store.dispatch("membership/uniqueMonthCheck");
    await this.init();
  },
};
</script>

<style>
.caption {
  background: #c5c5c5;
  color: black;

  display: inline-block;
  border-radius: 16px;
  font-size: 14px;
}
.right-icon {
  width: 16px;
  height: 16px;
  color: #4f0a4b;
}
.white-bg {
  border: #fff;
}
.swal-modal .swal-text {
  text-align: center;
}
.white-bg:hover {
  border: 2px solid #4f0a4b;
}
@media (max-width: 641px) {
  .mt-22rem {
    margin-top: 22rem !important;
  }
  .fsize18-14-32px {
    font-size: 14px !important;
    line-height: 22px;
  }
}
.bg-f0f0f0 {
  background: #f0f0f0;
}
table,
th,
td {
  border: 1px solid #f0f0f0;
}
.borbottom {
  border-bottom: 1px solid #f0f0f0;
}
.w-45per {
  width: 46%;
}
.borleft {
  border-left: 1px solid #f0f0f0;
}
.custboshodow {
  box-shadow: 5px -4px 10px -10px;
}
.custsubscribe.swiper-button-next {
  background-size: 40px 25px !important;
  right: -20px !important;
}
.custsubscribe.swiper-button-prev {
  background-size: 40px 25px !important;
  left: -13px !important;
}
.text-393939 {
  color: #393939;
}
.custboshodow .w-full {
  width: 100% !important;
}

@media (min-width: 641px) and (max-width: 768px) {
  .md-w-40 {
    width: 40% !important;
  }
  .w-70per {
    width: 70%;
  }
}
@media (max-width: 640px) {
  .pycard {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .f12 .el-radio__label {
    font-size: 12px;
  }
}
.w-75per {
  width: 75%;
}
.w-25per {
  width: 25%;
}
.lh-norm {
  line-height: normal;
}
.hide .el-dialog__header {
  display: none;
}
.cust-mod .el-dialog__body {
  padding: 23px 33px;
  color: #606266;
  font-size: 14px;
  word-break: normal;
}
.cust1 .el-dialog {
  border-radius: 14px;
}
</style>
